import { CommonUtilityModule } from './../shared/common-utility.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AvailabilityRoutingModule } from './availability-routing.module';
import { ListComponent } from './list/list.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedTranslateLazyModule } from '../shared/shared-translate-lazy.module';
import { LeftMenuModule } from '../shared/left-menu.module';
import { AddAvailabilityComponent } from './add-availability/add-availability.component';


@NgModule({
  declarations: [ListComponent, AddAvailabilityComponent],
  imports: [
    CommonModule,
    AvailabilityRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    SharedTranslateLazyModule,
    CommonUtilityModule,
    LeftMenuModule,
  ]
})
export class AvailabilityModule { }
